var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row-align-center"},[_c('div',{class:['state_icon', _vm.row[_vm.column.status_field] === '1' ? 'success' : 'info']}),_c('div',{staticClass:"ml-10 yx-color-text-primary"},[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }